import { Box, MenuItem, Select, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import noContent from '../../assets/images/trustpage_no_content.svg';
import { LANGUAGES } from '../../views/Research/SurveyTool/languages';
import survey from '../Survey/Survey';
import React from 'react';

interface INpsHeader {
  logo: string;
  logoLink?: string;
  languageKeys?: string[];
  selectedLanguage?: string;
  setSelectedLanguage?: (language: string) => void;
}

const SurveyHeader = ({
  logo,
  logoLink,
  languageKeys,
  selectedLanguage,
  setSelectedLanguage,
}: INpsHeader) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const logoStyle = {
    maxHeight: { xs: '26px', sm: '126px' },
    minHeight: { xs: '24px', sm: '30px' },
    maxWidth: { xs: '198px', sm: '248px' },
    height: 'auto',
    width: 'auto',
    objectFit: 'contain',
    m: { xs: theme.spacing(1.5), sm: theme.spacing(2) },
  };

  return (
    <Box
      className="survey-header"
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        borderBottom: `1px solid ${theme.palette.divider}`,
        pl: { xs: theme.spacing(1), sm: theme.spacing(2) },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          {logo ? (
            <Box
              className="survey-logo-wrapper"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'auto',
              }}
            >
              {logoLink ? (
                <Box
                  className="survey-logo-link"
                  component={'a'}
                  href={logoLink}
                  target={'_blank'}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <Box
                    className="survey-logo"
                    component={'img'}
                    sx={logoStyle}
                    alt={`${logo} ${t('logo_label')}`}
                    src={logo}
                  />
                </Box>
              ) : (
                <Box
                  className="survey-logo"
                  component={'img'}
                  sx={logoStyle}
                  alt={`${logo} ${t('logo_label')}`}
                  src={logo}
                />
              )}
            </Box>
          ) : (
            <Box
              className="survey-logo survey-logo--placeholder"
              component={'img'}
              sx={{
                ...logoStyle,
              }}
              alt={`${noContent} ${t('logo_label')}`}
              src={noContent}
            />
          )}
          {languageKeys && setSelectedLanguage && languageKeys.length > 1 && (
            <Select
              className="survey-language-select"
              value={selectedLanguage}
              onChange={(ev) => setSelectedLanguage(ev.target.value)}
            >
              {Object.entries(LANGUAGES)
                .filter(([key, lang]) => languageKeys.includes(key))
                .map(([key, lang]) => (
                  <MenuItem value={key}>
                    <Box
                      component="img"
                      src={lang.flag}
                      alt={lang.name}
                    />
                  </MenuItem>
                ))}
            </Select>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyHeader;
